module.exports = __webpack_public_path__ + "img/202307_05.20910b3b.jpg";